export const SystemSetupPages = {
	SystemSetup: {
		name: "system-setup",
		displayName: "System Setup",
	},
};
